import { render, staticRenderFns } from "./productlist.vue?vue&type=template&id=67d7d502&scoped=true"
import script from "./productlist.vue?vue&type=script&lang=js"
export * from "./productlist.vue?vue&type=script&lang=js"
import style0 from "./productlist.vue?vue&type=style&index=0&id=67d7d502&prod&scoped=true&lang=css"
import style1 from "./productlist.vue?vue&type=style&index=1&id=67d7d502&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7d502",
  null
  
)

export default component.exports